var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { makeAutoObservable } from "mobx";
import { MenuSearchService, } from "../ordering";
import { perRestaurant } from "../di";
import { PRestaurant } from "./PRestaurant";
let PMenuSearch = class PMenuSearch {
    constructor(restaurant, searchService) {
        this.searchService = searchService;
        this._state = { type: "Hidden" };
        this._searchableItems = null;
        this.menu = restaurant.menu;
        this.restaurantId = restaurant.id;
        makeAutoObservable(this);
    }
    get searchableItems() {
        if (this._searchableItems !== null)
            return this._searchableItems;
        const items = [];
        for (const section of this.menu.sections.objects.raw) {
            if (!section.isVisible)
                continue;
            for (const item of section.items.objects.raw) {
                const content = item.content;
                items.push({
                    sectionId: section.id,
                    sectionName: section.name,
                    sectionItem: item,
                    name: content.name,
                });
            }
        }
        this._searchableItems = items;
        return items;
    }
    get state() {
        return this._state;
    }
    get isOpen() {
        return this._state.type !== "Hidden";
    }
    open(query = "") {
        this._state = { type: "Init", query };
    }
    close() {
        this._state = { type: "Hidden" };
    }
    search(query) {
        query = query.trim();
        if (query.length === 0) {
            this._state = { type: "Init", query: "" };
            return;
        }
        if (query.length < 3) {
            return;
        }
        const results = this.searchService.search(this.searchableItems, query);
        if (results.length === 0) {
            this._state = { type: "Empty", query };
        }
        else {
            this._state = {
                type: "Results",
                query,
                items: results.map((r) => r.item),
            };
        }
    }
    clearQuery() {
        this._state = { type: "Init", query: "" };
    }
};
PMenuSearch = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [typeof (_a = typeof PRestaurant !== "undefined" && PRestaurant) === "function" ? _a : Object, typeof (_b = typeof MenuSearchService !== "undefined" && MenuSearchService) === "function" ? _b : Object])
], PMenuSearch);
export { PMenuSearch };
